import React from 'react';

export default function ComingSoon() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <h1 className="text-4xl font-bold text-indigo-600 mb-4">Coming Soon</h1>
      <p className="text-lg text-gray-700 mb-8 text-center max-w-md">
        This page is under construction. Please check back soon for updates!
      </p>
      <a href="/" className="bg-indigo-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-indigo-700 transition-colors">Go Home</a>
    </div>
  );
} 